// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 查询方式枚举 枚举类
 * 查询方式枚举
 */
export enum EnumSearchStyle {
  /** 精确查询 : 精确查询 */
  Equal = 1,
  /** 模糊查询 : 模糊查询 */
  Like = 2,
  /** 区间查询 : 区间查询 */
  Between = 4
}

/**
 * 查询方式枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumSearchStyleMD {
  private static items = [
    new EnumItemMD('Equal', 1, '精确查询', '精确查询'),
    new EnumItemMD('Like', 2, '模糊查询', '模糊查询'),
    new EnumItemMD('Between', 4, '区间查询', '区间查询')
  ];

  static getItem(enumItem: EnumSearchStyle) {
    return this.items.find(item => item.name === EnumSearchStyle[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
